<template>
  <PortalPageShell
    icon="mdi-account-circle"
    :title="$t('profile.title')"
    :subtitle="$t('portal.userProfile')"
  >
    <div class="portal-form-card profile-card">
      <ProfileFormSkeleton v-if="pageLoading" />

      <form v-else class="profile-form" @submit.prevent="editUser">
        <div class="profile-body">
          <section class="profile-section profile-section--account">
            <h3 class="profile-section-title">
              <span class="mdi mdi-account-outline profile-section-icon"></span>
              {{ $t('profile.accountSection') }}
            </h3>
            <div class="profile-fields profile-fields--row">
              <div class="profile-field">
                <label for="name">{{ $t('profile.name') }}</label>
                <input
                  type="text"
                  class="form-control profile-input"
                  id="name"
                  :placeholder="$t('profile.name')"
                  v-model="user.name"
                  readonly
                />
              </div>
              <div class="profile-field">
                <label for="email">{{ $t('profile.email') }}</label>
                <input
                  type="email"
                  class="form-control profile-input"
                  id="email"
                  :placeholder="$t('profile.email')"
                  v-model="user.email"
                  readonly
                />
              </div>
            </div>
          </section>

          <div class="profile-divider" aria-hidden="true"></div>

          <section
            class="profile-section profile-section--security"
            :class="{ 'profile-section--active': checkbox }"
          >
            <div class="profile-section-head">
              <h3 class="profile-section-title">
                <span class="mdi mdi-lock-outline profile-section-icon"></span>
                {{ $t('profile.securitySection') }}
              </h3>
              <label class="profile-toggle">
                <input
                  type="checkbox"
                  class="profile-toggle-input"
                  v-model="checkbox"
                  @change="onPasswordToggle"
                />
                <span class="profile-toggle-track"></span>
                <span class="profile-toggle-label">{{ $t('profile.changepassword') }}</span>
              </label>
            </div>

            <div
              class="profile-fields profile-fields--row profile-fields--password"
              :class="{ 'is-disabled': !checkbox }"
            >
              <div class="profile-field">
                <label for="profile-password">{{ $t('profile.password') }}</label>
                <input
                  type="password"
                  class="form-control profile-input"
                  id="profile-password"
                  :placeholder="$t('profile.password')"
                  v-model="user.password"
                  :disabled="!checkbox"
                  autocomplete="new-password"
                />
              </div>
              <div class="profile-field">
                <label for="profile-confirm-password">{{ $t('profile.confirmpassword') }}</label>
                <input
                  type="password"
                  class="form-control profile-input"
                  id="profile-confirm-password"
                  :placeholder="$t('profile.confirmpassword')"
                  v-model="user.confirmPassword"
                  :disabled="!checkbox"
                  autocomplete="new-password"
                />
              </div>
            </div>
            <p v-if="!checkbox" class="profile-hint">{{ $t('profile.passwordHint') }}</p>
          </section>
        </div>

        <footer class="profile-footer">
          <ul v-if="errors.length" class="profile-errors">
            <li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
          </ul>
          <div v-else class="profile-footer-spacer"></div>

          <div class="profile-actions">
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm profile-btn"
              :disabled="!checkbox || submitting"
              @click="resetPasswordFields"
            >
              {{ $t('deletepop.cancelbtn') }}
            </button>
            <button
              type="submit"
              class="btn btn-primary btn-sm profile-btn"
              :disabled="!checkbox || submitting"
            >
              {{ $t('profile.savebtn') }}
            </button>
          </div>
        </footer>
      </form>
    </div>
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../components/layout/PortalPageShell.vue';
import ProfileFormSkeleton from '../components/ProfileFormSkeleton.vue';
import { decryptData } from '../js/utils/encrypt';
import axios from 'axios';
import { routeNames } from '../js/routeNames';
export default {
  components: {
    PortalPageShell,
    ProfileFormSkeleton,
  },
  data() {
    return{
      username: '',
      permissions: [],
      role: '',
      user: {
        id: '',
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      pageLoading: false,
      submitting: false,
      errors:[],
      nameCheck: '',
      emailCheck: '',
      checkbox: false,
    };
  },
  mounted () {
    this.username = localStorage.getItem('username').replace(/['"]+/g,'');
    let permissions = localStorage.getItem('Permissions');
    let role = localStorage.getItem('Role');
    const secretKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(permissions, secretKey);
    this.role = decryptData(role, secretKey);
    this.loadProfile();
  },
  computed: {
    routeNames: () => { return routeNames; }
    },
  methods:{
    refreshPortalPage() {
      this.loadProfile();
    },
    loadProfile() {
      this.pageLoading = true;
      axios
        .get(this.$hostName + '/getUser')
        .then((response) => {
          this.user = response.data;
          this.nameCheck = response.data.name;
          this.emailCheck = response.data.email;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    onPasswordToggle() {
      if (!this.checkbox) {
        this.resetPasswordFields();
      }
    },
    resetPasswordFields() {
      this.checkbox = false;
      this.user.password = '';
      this.user.confirmPassword = '';
      this.errors = [];
    },
     editUser(e){
      this.errors = [];
      if(this.user.name=='' || this.user.email=='' || this.user.password==undefined || this.user.confirmPassword==undefined){
          if(this.user.name==''){
            this.errors.push('Name required.');
          }
          if(this.user.email==''){
            this.errors.push('Email required.');
          }
          if(this.user.password=='' || this.user.password==undefined){
            this.errors.push('Password required.');
          }
          if(this.user.confirmPassword=='' || this.user.confirmPassword==undefined){
            this.errors.push('Password confirmation required.');
          }
          if (!this.errors.length) {
            return true;
          }
          e.preventDefault();
          return;
      }

          if(this.user.name!='' || this.user.email!='' || this.user.password!='' || this.user.confirmPassword!=''){
            if(this.user.password.length<6){
              this.errors.push('Minimum 6 characters required.');
            }
            if(this.user.password!=this.user.confirmPassword){
               this.errors.push('Password and Confirm Password does not match');
               return;
             }
            if(this.user.email!=''){
              if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)){
                console.log('skip');
              }
              else{
                this.errors.push('Incorrect email format');
                return;
              }
            }
          }

      this.submitting = true;
      axios.put(this.$hostName + '/account/update/'+ this.user.id,{
          name: this.user.name,
          email: this.user.email,
          password: this.user.password,
          nameCheck: this.nameCheck,
          emailCheck: this.emailCheck
        }).then(response =>{
          if(response.status==202){
            this.submitting = false;
            this.$alert('User already exists');
          }
          else if(response.status==203){
            this.submitting = false;
            this.$alert('Email already exists');
          }
          else{
            this.logout();
          }
        });
    },
    logout() {
      localStorage.removeItem('Login');
      if(routeNames.login == this.$router.currentRoute.name) {
        location.reload();
        return;
      }
      axios.post(this.$hostName + '/logout', null)
      .then(() =>{
          this.submitting = false;
          this.$router.push({ name: routeNames.login});
        }).catch((error) =>{
          this.errors = error.response.data.errors;
        }).finally(() => {
            localStorage.removeItem('token');
            localStorage.removeItem('Permissions');
            localStorage.removeItem('username');
            localStorage.removeItem('Role');
            location.reload();
        });
    },
  }
};
</script>
<style scoped lang="scss">
.profile-card {
  position: relative;
  width: 100%;
  max-width: none;
  padding: 18px 22px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1 auto;
  min-height: 0;
}

.profile-body {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  min-height: 120px;
}

.profile-divider {
  width: 1px;
  flex-shrink: 0;
  margin: 0 20px;
  background: linear-gradient(
    180deg,
    transparent 0%,
    hsl(211, 35%, 88%) 12%,
    hsl(211, 35%, 88%) 88%,
    transparent 100%
  );
}

.profile-section {
  flex: 1 1 0;
  min-width: 0;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid hsl(211, 35%, 92%);
  background: hsl(211, 55%, 98%);
  transition: border-color 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;

  &--security.profile-section--active {
    border-color: rgba($brand-primary, 0.35);
    box-shadow: 0 0 0 3px rgba($brand-primary, 0.08);
    background: $general-white;
  }
}

.profile-section-head {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.profile-section-title {
  margin: 0 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: $brand-primary-dark;
  flex-shrink: 0;
}

.profile-section--account .profile-section-title {
  margin-bottom: 12px;
}

.profile-section-head .profile-section-title {
  margin-bottom: 0;
}

.profile-section-icon {
  font-size: 1.1rem;
  color: $brand-primary;
  line-height: 1;
}

.profile-fields {
  flex: 1 1 auto;
  min-width: 0;

  &--row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 12px 16px;
    align-content: start;
  }

  &--password.is-disabled .profile-input {
    background: hsl(211, 30%, 96%);
    cursor: not-allowed;
  }
}

.profile-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;

  label {
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    color: $brand-primary-dark;
  }
}

.profile-input {
  height: 34px;
  padding: 6px 10px;
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid rgba($brand-primary, 0.2);
  color: $general-black-light;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus {
    border-color: $brand-primary;
    box-shadow: 0 0 0 3px rgba($brand-primary, 0.12);
    outline: none;
  }

  &:read-only {
    background: hsl(211, 40%, 97%);
    color: hsl(211, 15%, 42%);
    cursor: default;
  }

  &:disabled {
    background: hsl(211, 30%, 96%);
    opacity: 0.85;
  }
}

.profile-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  cursor: pointer;
  user-select: none;
}

.profile-toggle-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;

  &:checked + .profile-toggle-track {
    background: $brand-primary;

    &::after {
      transform: translateX(16px);
    }
  }

  &:focus-visible + .profile-toggle-track {
    box-shadow: 0 0 0 3px rgba($brand-primary, 0.25);
  }
}

.profile-toggle-track {
  position: relative;
  width: 36px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 10px;
  background: hsl(211, 20%, 78%);
  transition: background 0.2s;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: $general-white;
    box-shadow: 0 1px 3px rgba(24, 40, 72, 0.2);
    transition: transform 0.2s;
  }
}

.profile-toggle-label {
  font-size: 12px;
  font-weight: 600;
  color: $brand-primary-dark;
}

.profile-hint {
  margin: 8px 0 0;
  font-size: 11px;
  color: hsl(211, 15%, 48%);
  font-style: italic;
  line-height: 1.3;
}

.profile-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid hsl(211, 35%, 92%);
  flex-shrink: 0;
}

.profile-footer-spacer {
  flex: 1 1 auto;
  min-width: 0;
}

.profile-errors {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  padding: 8px 12px;
  list-style: none;
  border-radius: 6px;
  background: hsl(0, 80%, 97%);
  border: 1px solid hsl(0, 55%, 88%);
  font-size: 12px;
  color: hsl(0, 65%, 42%);
  li {
    display: inline-block;

    & + li::before {
      content: ' · ';
      color: hsl(0, 40%, 65%);
    }
  }
}

.profile-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.profile-btn {
  min-width: 88px;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
  line-height: 1.4;
}

.btn-primary.profile-btn {
  background: $brand-primary;
  border-color: $brand-primary;

  &:hover:not(:disabled) {
    background: $brand-primary-dark;
    border-color: $brand-primary-dark;
  }

  &:disabled {
    opacity: 0.5;
  }
}

.btn-outline-secondary.profile-btn {
  color: $brand-primary-dark;
  border-color: rgba($brand-primary, 0.35);

  &:hover:not(:disabled) {
    background: hsl(211, 55%, 96%);
    color: $brand-primary-dark;
  }
}

@media screen and (max-width: 900px) {
  .profile-body {
    flex-direction: column;
    gap: 14px;
    min-height: 0;
  }

  .profile-divider {
    display: none;
  }

  .profile-section-head {
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 560px) {
  .profile-card {
    padding: 14px 12px;
  }

  .profile-fields--row {
    grid-template-columns: 1fr;
  }

  .profile-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .profile-actions {
    justify-content: flex-end;
  }
}
</style>
